import { createContext } from 'react';
import { initialState } from '../reducer/myAccountInitialState';
import { initialPathState } from '../reducer/pathInitialState';
import { initialConfigurationState } from '../reducer/configurationInitialState';
import { initialCaptchaPuzzleState } from '../reducer/captchaPuzzleInitialState';

export const myAccountContext = createContext(initialState);
export const pathContext = createContext(initialPathState);
export const configurationContext = createContext(initialConfigurationState);
export const captchaPuzzleContext = createContext(initialCaptchaPuzzleState);
